import { render, staticRenderFns } from "./msgDetails.vue?vue&type=template&id=456e5974&"
import script from "./msgDetails.vue?vue&type=script&lang=js&"
export * from "./msgDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "msgDetails.vue"
export default component.exports